import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("pb24_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Session 37 · Phase 2 · Journey-Session-ID mitschicken (falls vorhanden).
  // Backend nutzt den Header, um Buchungen/Anfragen mit der Journey zu
  // verknüpfen. Kein PII, nur pseudonyme UUID.
  try {
    const sid = localStorage.getItem("pb24_journey_sid");
    if (sid) config.headers["X-Journey-Session-Id"] = sid;
  } catch (_) { /* noop */ }
  return config;
});

export function extractError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return err?.message || "Unbekannter Fehler";
}

export default client;
